import styled from "styled-components";

export const FooterWrapper = styled.footer`
  margin: 0 auto;
`;
